// SDK 尚未載入時，方法呼叫只能回傳「稍後才會有結果」的值。若直接回傳原生 Promise，
// 呼叫端對 kwaiq.instance(pixelId) 這種「工廠方法」續接 .track() 會取到 undefined 並拋
// TypeError（?. 只擋 null/undefined，擋不住「屬性存在但不是函式」），例外由 analytics
// plugin 冒泡上去會讓整頁進 Nuxt 500 錯誤狀態。
// 故改回傳同時可 await、也可繼續鏈式呼叫的延遲代理。
export const createDeferredProxy = (promise) =>
  new Proxy(
    {},
    {
      get(_target, prop) {
        if (prop === 'then' || prop === 'catch' || prop === 'finally') {
          return promise[prop].bind(promise)
        }
        if (typeof prop === 'symbol') {
          return undefined
        }
        return (...args) => createDeferredProxy(promise.then((value) => (typeof value?.[prop] === 'function' ? value[prop](...args) : undefined)))
      },
    }
  )

export default defineNuxtPlugin(() => {
  // 等待 kwaiq 載入的 Promise
  const waitForKwaiq = () => {
    return new Promise((resolve) => {
      if (window.kwaiq && typeof window.kwaiq.load === 'function') {
        resolve(window.kwaiq)
        return
      }

      // 每 100ms 檢查一次，最多等待 10 秒
      let attempts = 0
      const maxAttempts = 100
      const interval = setInterval(() => {
        attempts++
        if (window.kwaiq && typeof window.kwaiq.load === 'function') {
          clearInterval(interval)
          resolve(window.kwaiq)
        } else if (attempts >= maxAttempts) {
          clearInterval(interval)
          resolve({}) // 返回空對象作為 fallback
        }
      }, 100)
    })
  }

  // 立即返回一個代理對象，實際調用時會等待 kwaiq 載入
  const kwaiqProxy = new Proxy(
    {},
    {
      get(target, prop) {
        if (!target._kwaiq) {
          // 第一次訪問時開始等待
          target._promise =
            target._promise ||
            waitForKwaiq().then((kwaiq) => {
              target._kwaiq = kwaiq
              console.info('[kwaiq] SDK loaded successfully')
              return kwaiq
            })
        }

        return (...args) => {
          if (target._kwaiq && typeof target._kwaiq[prop] === 'function') {
            return target._kwaiq[prop](...args)
          }
          // 如果還在等待，先排隊
          return createDeferredProxy(
            target._promise.then((kwaiq) => {
              if (kwaiq && typeof kwaiq[prop] === 'function') {
                return kwaiq[prop](...args)
              }
            })
          )
        }
      },
    }
  )

  return {
    provide: {
      kwaiq: kwaiqProxy,
    },
  }
})
